<!--掛號說明維護-->
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-flex xs12>
        <v-card class="cardBgColorStyle">


            <v-card row wrap dark xs12 sm12 md12 lg12  color="secondary"  dense style="padding:0px 0px">

                <v-flex  d-inline-flex style="margin-bottom: -5px">
                    <v-btn @click="addItem"  dark fab top right color="accent" class="mb-2 mt-0">
                        <v-icon >mdi-plus</v-icon>
                    </v-btn>
                </v-flex>

                <!--程式名稱-->
                <v-flex d-inline-flex pl-2 style="font-size: 1.2rem;vertical-align: middle;margin-bottom: 15px;">
                    <!--<span>{{this.menuInfo.funTitle}} 掛號說明維護</span>-->
                    <span> 掛號說明維護</span>
                </v-flex>


                <!--<v-flex class="row wrap pl-2 xs12 sm12 md12"   style="margin-bottom: -10px">-->

                    <v-flex xs12 sm6 md4 d-inline-flex ml-2>
                        <v-autocomplete
                                @change="axios_getRegNote (zone,noteType,codeNo==''?'ALLCODE':codeNo)"
                                v-model="noteType"
                                hide-details
                                :items="this.noteTypeList"
                                :item-text="regNoteItemText"
                                item-value="value1"
                                label="Note類別"
                        ></v-autocomplete>
                    </v-flex>

                <v-flex xs12 sm6 md3 d-inline-flex ml-2>
                    <v-text-field
                            @keyup.enter="axios_getRegNote (zone,noteType,codeNo==''?'ALLCODE':codeNo)"
                            v-model="codeNo"
                            label="科別診間代號"
                    ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md2 d-inline-flex ml-2>

                    <v-select
                            @change="axios_getRegNote (zone,noteType,codeNo==''?'ALLCODE':codeNo)"
                            v-if="zoneNameList.length>0"
                            dark
                            v-model="zone"
                            hide-details
                            :items="zoneNameList"
                            :item-text="zoneItemText"
                            item-value="zone"
                            label="院區代號"
                    ></v-select>


                    <v-text-field
                            v-else
                            @keyup.enter="axios_getRegNote (zone,noteType,codeNo==''?'ALLCODE':codeNo)"
                            v-model="zone"
                            label="院區代號"
                    ></v-text-field>
                </v-flex>







                    <v-btn icon dark  top right style="margin: 10px 15px;"   @click="axios_getRegNote (zone,noteType,codeNo==''?'ALLCODE':codeNo)">
                        <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                    <!--<v-btn mt-2 color="primary"  @click="">查詢</v-btn>-->


                <!--</v-flex>-->



            </v-card>


            <v-flex style="padding-top: 1rem">
                <v-data-table
                        dense
                        id="sysSetTable"
                        @page-count="pagination.pageCount = $event"
                        :page.sync="pagination.page"
                        :sort-by="pagination.sortBy"
                        :sort-desc="pagination.descending"
                        :loading-text="loadingText"
                        :loading="sysSetLoading"
                        :headers="sysSetHeaders"
                        :items="sysSetList"
                        :search="search"
                        :items-per-page="pagination.rowsPerPage"
                        hide-default-footer
                        hide-default-header
                        item-key="chart_no"
                        v-resize="resizeSysSetListGrid"
                        class="elevation-1">

                    <template v-slot:header="{ props }">
                        <tr class="px-1 text-left tablehead">
                            <th v-for="header in props.headers"
                                :key="header.text"
                                :class="['column sortable',pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '','px-1']"
                                @click="changeSort(header.value)">
                                <span  v-html="header.text"></span>
                                <v-icon small
                                        :style="{display:header.value === pagination.sortBy ? pagination.descending ? 'none' : 'inline' : 'none'}">
                                    mdi-arrow-up
                                </v-icon>
                                <v-icon small
                                        :style="{display:header.value === pagination.sortBy ? pagination.descending ? 'inline' : 'none' : 'none'}">
                                    mdi-arrow-down
                                </v-icon>
                            </th>
                        </tr>
                    </template>

                    <template slot="item" slot-scope="props" style="border: 1px solid black">
                        <!--<tr :active="props.selected" @click="props.selected = !props.selected">-->
                        <!--<td>
                          <v-checkbox :input-value="props.selected" primary hide-details></v-checkbox>
                        </td>-->
                        <tr>
                            <td class=" align-space-around justify-space-around fill-height px-0" >
                                <v-layout>
                                    <v-btn  icon class="mx-0" @click.native.stop="editItem(props.item)">
                                        <v-icon color="tertiary">mdi-pencil</v-icon>
                                    </v-btn>
                                    <v-btn   icon class="mx-0" @click.native.stop="deleteItem(props.item)">
                                        <v-icon color="tertiary">mdi-delete</v-icon>
                                    </v-btn>
                                </v-layout>
                            </td>
                            <td  class="px-1 text-left">{{ props.item.displaySeq}}</td>
                            <td  class="px-1 text-left">{{ props.item.noteType}}</td>
                            <td  class="px-1 text-left">{{ props.item.codeNo}}</td>
                            <td  class="px-1 text-left">{{ props.item.zone}}</td>
                            <td  class="px-1 text-left" v-html="props.item.regNote" style="white-space: pre-line;"></td>


                        </tr>
                    </template>
                    <template slot="pageText" slot-scope="props">
                        第 {{ props.pageStart }} - {{ props.pageStop }} ,共 {{ props.itemsLength }} 筆
                    </template>
                    <template slot="no-data">
                        <v-alert :value='countDownNo>=5' type="warning" icon="mdi-alert-circle">
                            查詢中...
                        </v-alert>
                        <v-alert :value='tableAlert' color="info" icon="mdi-information">
                            表格中沒有內容
                        </v-alert>
                    </template>
                    <!--<v-alert slot="no-results" :value="true" color="info" icon="mdi-alert-circle">-->
                    <!--Your search for " {{ search }} " found no results.-->
                    <!--</v-alert>-->
                </v-data-table>
                <v-layout row wrap>
                    <v-flex xs12 md2>
                        <v-text-field
                                v-model="search"
                                class="ml-2 mt-2"
                                prepend-inner-icon="mdi-magnify"
                                single-line
                                hide-details
                                clearable
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6 text-center pt-2>
                        <v-pagination color="accent" v-model="pagination.page" :length="pagination.pageCount" :total-visible="7"></v-pagination>
                    </v-flex>
                    <v-flex xs6 md2 pt-2 pr-2 pl-2>
                        <v-select
                                :items="pageItem"
                                label="每頁筆數"
                                item-value="value"
                                v-model="pagination.rowsPerPage"
                        ></v-select>
                    </v-flex>
                    <v-flex xs6 md2 text-left pt-2 pr-2>
                        <v-text-field
                                label="總筆數"
                                v-model="sysSetList.length"
                                readonly
                        ></v-text-field>
                    </v-flex>
                </v-layout>
            </v-flex>


        </v-card>

        <v-dialog v-model="editDialog"
                  eager
                  xs6 sm6 md6
                  :width="editDialogWidth+'%'"
                  value="false"
                  scrollable>
            <edit-reg-note :zone-name-list="zoneNameList" :note-type-list="noteTypeList" :is-show="editDialog" @closeDialog="closeDialog" @save="save" :edit-index="editIndex" :edit-obj="editObj"></edit-reg-note>
        </v-dialog>

        <v-dialog v-model="deleteDialog"
                  width="50%"
                  xs6 sm6 md6
                  value="false"
                  scrollable>
            <delete-info-dialog @closeDelete="closeDelete" @confirmDelete="confirmDelete" :delete-title="deleteTitle" :delete-content="deleteContent"></delete-info-dialog>
        </v-dialog>

        <!-- 我是 snackbar -->
        <v-snackbar
                :timeout="snTimeout"
                v-model="snStatus">
            {{snText}}
        </v-snackbar>


    </v-flex>
</template>

<script>
    import DeleteInfoDialog from './DeleteInfoDialog'
    import EditRegNote from './EditRegNote'
    export default {
        name: "RegNote",
        components: {DeleteInfoDialog,EditRegNote},
        data() {
            return {
                zoneNameList:[],
                zone:'A',
                countDownId: null, //data 定義一個定時器id
                countDownNo:0,
                sysSetLoading:false,
                loadingText:'查詢中...',
                tableAlert:false,
                search:'',
                snTimeout:4000,
                snStatus:false,
                snText:'',
                deleteDialog:false,
                deleteTitle:'刪除 掛號說明',
                deleteContent:'',
                deleteObj:{},
                editDialog:false,
                editIndex:-1,
                editObj:{},
                sysSetList: [],
                codeNo:'',
                pagination: {
                    sortBy: 'dataType',
                    rowsPerPage:100,
                    page: 1,
                    pageCount: 0,
                    descending:false
                },
                pageItem:[
                    {text:100,value:100},
                    {text:20,value:20},
                    {text:"All",value:-1},
                ],
                pageText:'每頁筆數 :',
                sysSetHeaders:[
                    {
                        text: '',
                        align: 'center',
                        // value: 'assessDate'
                    },
                    {
                        text: '顯示順序',
                        // align: 'center',
                        value: 'displaySeq',
                        class:'px-1'
                    },
                    {
                        text: 'Note類別',
                        // align: 'center',
                        value: 'noteType',
                        class:'px-1'
                    },
                    {
                        text: '科別/診間代號',
                        // align: 'left',
                        value: 'codeNo',
                        class:'px-1'
                    },
                    {
                        text: '院區代號',
                        // align: 'left',
                        value: 'zone',
                        class:'px-1'
                    },
                    {
                        text: '掛號說明',
                        // align: 'center',
                        value: 'regNote',
                        class:'px-1'
                    },
                ],
                noteTypeList:[], //Note類別清單
                noteType:'',
            }
        },
        created(){
            this.axios_getNoteTypeList();
            this.axios_getZoneNameALL();
        },
        computed:{
            menuInfo() {
                return this.$store.state.menuInfo;
            },
            editDialogWidth(){ //隨畫面大小 調整Dialog的寬度
                let width = 50;
                if (this.$vuetify.breakpoint.xs == true) {width = 100 }
                if(this.$vuetify.breakpoint.sm == true){width = 97}
                if(this.$vuetify.breakpoint.md == true){width =  60}
                if(this.$vuetify.breakpoint.lg == true){width =  70}
                if(this.$vuetify.breakpoint.xl ==true){width =  70}
                return width
            },
        },
        watch:{
        },
        methods:{
            zoneItemText: item => item.zone==''?'':item.zone + '-' + item.zoneName, //格式化 院區顯示文字
            regNoteItemText: item => item.value1==''?'':item.value1 + '-' + item.memo, //格式化 autocomplete 選權限顯示文字
            countDown(){
                if(this.countDownId != null ) return;
                this.countDownId = setInterval(() => {
                    this.countDownNo++
                },1000)
            },
            //停止計時器
            stopCountDown(){
                clearInterval(this.countDownId);
                //當我清除定時器之後，重新讓intervalId為null
                this.countDownId = null;
                this.countDownNo=0;
            },
            changeSort: function(column) {
                // console.log(column);
                if (this.pagination.sortBy === column) {
                    this.pagination.descending = !this.pagination.descending
                } else {
                    this.pagination.sortBy = column;
                    this.pagination.descending = false
                }
            },
            closeDelete(){
                this.deleteDialog = false;

            },
            confirmDelete(){
                this.axios_deleteRegNote(this.deleteObj);
            },
            addItem(){  //新增按鈕
                this.editDialog = true;
                this.editIndex = -1;
            },
            closeDialog(){ //關閉編輯視窗
                this.editDialog = false;
            },
            editItem:function(item){
                this.editIndex = this.sysSetList.indexOf(item);
                this.editObj = item;
                this.editDialog = true;
            },
            deleteItem:function(item){  //刪除
                this.deleteObj = item;
                this.deleteDialog = true;
                this.deleteContent = '確定要刪除，[Note類別'+item.noteType+" /科別/診間代號"+item.codeNo+"]記錄";
            },
            save(item){
                if(this.editIndex==-1){ //新增
                    this.axios_postRegNote(item);
                }else { //修改
                    this.axios_putRegNote(item);
                }
            },
            resizeSysSetListGrid:function(){
                var userHeight = window.innerHeight
                    || document.documentElement.clientHeight
                    || document.body.clientHeight;
                var height = userHeight-(275);
                var sysSetTable = document.getElementById('sysSetTable');
                sysSetTable.setAttribute('style','overflow-y: auto;min-height:'+height+'px;max-height:'+height+'px;');
            },
            axios_getRegNote (zone,noteType,codeNo){ //參數代碼查詢
                let url = '';
                if(noteType!==''&&codeNo!==""){
                    this.countDown();
                    this.sysSetLoading = true;
                    this.tableAlert = false;
                    this.sysSetList = [];
                    // let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                    url = this.$store.state.AppSetting.backSrvUrl + "regnote/datasearch/primarykeys/"+zone+"/"+noteType+"/"+codeNo;

                    // http://172.16.1.72:8080/iRegaSrv/rest/regnote/datasearch/primarykeys/tan/A/ALL/05

                    this.$http.get(url).then(response =>{
                        if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                            this.sysSetList = response.data.resultSet;
                            this.sysSetLoading = false;
                            this.stopCountDown();
                        }else{
                            this.tableAlert = true;
                            this.sysSetList = [];
                            this.sysSetLoading = false;
                            this.stopCountDown();
                        }


                    }).catch(error =>  {
                        try {
                            console.log(error.response.data.status);
                            this.sysSetList = [];
                        } catch(err) {
                            this.sysSetLoading = false;
                        }
                        this.sysSetLoading = false;
                        this.stopCountDown();
                    });

                }else {
                    alert('請選擇 Note類別且輸入科別或診間代號');
                }
            },
            axios_postRegNote(postData){ //新增 掛號說明
                let postList = [];
                postList.push(postData);
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                let url = this.$store.state.AppSetting.backSrvUrl+'regnote/'+zone;

                this.$http.post(url,postList).then(response=>{
                    this.snStatus=true;
                    this.snText = response.data.message;
                    if(response.data.resultSet.length>0&& response.data.hasOwnProperty('resultSet')){
                        this.editDialog = false;
                        this.axios_getRegNote(postData.zone,postData.noteType,postData.codeNo)
                        this.zone = postData.zone;

                    }
                    this.snText = response.data.message;
                }).catch(error =>{
                    try{
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }catch (e) {
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }
                });
            },
            axios_putRegNote(putData){ //修改 資料來源
                let postList = [];
                postList.push(putData);
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                let url = this.$store.state.AppSetting.backSrvUrl+'regnote/'+zone;

                this.$http.put(url,postList).then(response=>{
                    this.snStatus=true;
                    this.snText = response.data.message;
                    if(response.data.resultSet.length>0){
                        this.editDialog = false;
                        this.axios_getRegNote(putData.zone,putData.noteType,putData.codeNo);
                        this.zone = putData.zone;
                    }
                }).catch(error =>{
                    try{
                        this.snStatus=true;
                        this.snText = error.response.data.message;

                    }catch (e) {
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }
                });
            },
            axios_deleteRegNote(item){   //刪除單筆資料
                let url = this.$store.state.AppSetting.backSrvUrl+'regnote/s/'+item.zone+"/"+item.noteType+"/"+item.codeNo;

                this.$http.delete(url).then(response=>{
                    this.snStatus=true;
                    this.snText = response.data.message;
                    if(response.data.resultSet.length>0){
                        this.axios_getRegNote(item.zone,item.noteType,item.codeNo);
                        this.zone = item.zone;
                        this.deleteDialog = false;
                    }

                }).catch(error =>{
                    try{
                        this.snStatus=true;
                        this.snText = error.response.data.message;

                    }catch (e) {
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }
                });
            },

            axios_getNoteTypeList (){ //取得NoteType 清單
                this.noteTypeList = [];
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "iregsetting/datasearch/bygroupidcode/LIST/NOTETYPE";

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.noteTypeList = response.data.resultSet;
                    }else{
                        this.noteTypeList = [];
                    }

                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.noteTypeList = [];
                    } catch(err) {
                        this.noteTypeList = [];
                    }
                });
            },
            axios_getZoneNameALL (){  //查詢院區名稱
                this.zoneNameList =[];
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "zoneset/datasearch/primarykeys/ALL";
                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.zoneNameList = response.data.resultSet;
                    }else{
                        this.zoneNameList =[];
                    }
                }).catch(error =>  {
                    this.zoneNameList =[];
                    try {
                        console.log(error.response.data.status);

                    } catch(err) {
                        console.log(err.toString())
                    }
                });
            },

        }

    }
</script>

<style scoped>

    .cardBgColorStyle{
        padding:0px 10px;
        background-color: rgba(255,255,255,1);
    }

</style>